import { render } from "./UserCategoriesView.vue?vue&type=template&id=6c1d8924"
import script from "./UserCategoriesView.vue?vue&type=script&lang=js"
export * from "./UserCategoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__